var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7722 14.5949L12.5466 21.7744C12.4754 21.8452 12.3898 21.9014 12.2959 21.9404C12.2019 21.9794 12.1007 22 11.9995 22C11.8983 22 11.7981 21.9794 11.7031 21.9404C11.6082 21.9014 11.5236 21.8452 11.4524 21.7744L4.22683 14.5949C3.92439 14.2944 3.92439 13.8072 4.22683 13.5067C4.52927 13.2061 5.01961 13.2061 5.32205 13.5067L11.2263 19.3733V2.76923C11.2263 2.34462 11.5732 2 12.0005 2C12.4278 2 12.7747 2.34462 12.7747 2.76923V19.3733L18.679 13.5067C18.9814 13.2061 19.4717 13.2061 19.7742 13.5067C20.0766 13.8072 20.0746 14.2944 19.7722 14.5949Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.5a318a05fbd6db1160687d56b9358c77.svg";
export { ForwardRef as ReactComponent };